import { adminRoles } from '@/constants';
import { checkAndRedirectForOrgAdminAccess } from '@/helpers';
import { fetchOrganizations } from '@/pages/Organizations/orgUtils';
import { useAppStore } from '@/stores/app';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/organizations/')({
  beforeLoad: ({ context, location }) => {
    const selectedOrganization = useAppStore.getState().selectedOrganization;
    checkAndRedirectForOrgAdminAccess({
      context,
      location,
      selectedOrganization,
      adminRoles,
      redirect,
    });
  },
  loader: async () => {
    const orgs = await fetchOrganizations();
    return Array.isArray(orgs) ? orgs : [];
  },
});
